<template>
  <Container type="card-full">
    <div slot="header">
      <el-button type='primary' @click="save" :loading="btnLoading">保存</el-button>
      <!-- <el-button @click="close">关闭</el-button> -->
    </div>
    <div>
      <el-form :model="pmlb" label-position="right" class="mainfrom">
        <el-form-item label="服务类型" class="from-value">
          {{pmName.syscodename}}
        </el-form-item>
        <el-form-item label="起始金额" class="from-value"  prop="chargefeerate">
          <div class="from_input">
            <el-input v-model="pmlb.chargefeebeg" :maxlength="18"></el-input>
          </div>
        </el-form-item>
        <el-form-item label="终止金额" class="from-value"  prop="chargefeerate">
          <div class="from_input">
            <el-input v-model="pmlb.chargefeeend" :maxlength="18"></el-input>
          </div>
        </el-form-item>
        <el-form-item label="费率" class="from-value"  prop="chargefeerate">
          <div class="from_input">
            <el-input v-model="pmlb.chargefeerate" :maxlength="12"></el-input>
          </div>
        </el-form-item>
      </el-form>
    </div>
  </Container>
</template>

<script>
  import request from '@/utils/request'
  import utils from '../../assets/js/utils'
  import uploadPicOne from '../common/uploadPicOne'
  import popoverImg from '../common/popoverImg'
  import _ from 'lodash'
  export default {
    name: "pmlbform",
    data () {
      return {
        btnLoading: false,
        pmlb: this.$route.params.form,
        pmName:{}
      }
    },
    created () {
    },
    activated () {
      this.init()
      this.getpmName()
    },
    watch: {},
    filters: {
    },
    components: {uploadPicOne, popoverImg},
    computed: {
    },
    methods: {
      setThousand (value) {
        return utils.comdify(value)
      },
      btnClick (code) {
        this.$emit(code)
      },
      async init () {
        this.pmlb = this.$route.params.form
        this.btnLoading = false
        this.pmName = {}
      },
      async save () {
        this.btnLoading = true
        this.pmlb.chargefeebeg =  utils.delcommafy(this.pmlb.chargefeebeg)
        this.pmlb.chargefeeend =  utils.delcommafy(this.pmlb.chargefeeend)
        let data = await request({
          url: '/basic/pm/savepmfl',
          method: "post",
          data: this.pmlb
        })
        if (data.issuccess === 1) {
          this.close()
          this.$message.success('修改费率成功')
        } else {
          this.$message.error('修改费率失败')
        }
        this.btnLoading = false
      },
      close () {
        this.$store.commit('close_tab', {routeName: this.$route.name, vm: this, newRouteName: 'pmlbindex'})
      },
      async getpmName(){
        let data = await request({
          url: '/basic/pm/getpmName',
          method: "get",
          params:{syscode: 'chargefeetype',pmlb:this.pmlb.chargefeetype}
        })
        this.pmName = data[0]
      }
    }
  }
</script>

<style scoped>

</style>
